import _ from 'lodash';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { showMessage } from '~/helper';
import useFetch from '~/view-data/use-fetch';
import api from '~/services/api';
import useGlobalContext from './use-global-context';
import useHeader from './use-header';

const initialState = {
  selecteds: [],
  roles: [],
  showAreaModal: false,
  modalData: {},
  filter: { name: '', area: '', role: '' }
};

const statusMap = {
  'accreditation': 'Credenciamento',
  'checklist': 'Visualização',
  'running': 'Visualização',
  'finished': 'Visualização',
}

function useEventAccredit(history) {
  const { id } = useParams(),
    { actions: headerActions } = useHeader(),
    { state: { eventAccredit = initialState }, dispatch } = useGlobalContext();

  const { data, mutate, error } = useFetch({ url: 'events/load-accredit', params: { id } });

  const failure = (error) => {
    dispatch({ type: 'eventAccredit', payload: { loading: false }});
    showMessage('error', error);
  };
  
  if (error) {
    failure(error);
    history.push('/events');
  }

  useEffect(() => {
    (async () => {
      headerActions.configure({
        title: `Evento (#${id}) - ${statusMap[_.get(data, 'status')] || ''}`,
        loading: !data
      });
      await loadRoles();
    })()
    // eslint-disable-next-line
  }, [data]);

  const loadRoles = async () => {
    try {
      const { data } = await api.get(`events/roles`);
      dispatch({ type: 'eventAccredit', payload: { roles: data } });
    } catch (error) {
      failure(error, dispatch);
    }
  };

  const changeArea = async (value, selection) => {   
    try {
      let params = { personsId: _.isEmpty(selection) ? [ value.id ] : selection, eventId: id, area: value.area };
      await api.put(`events/save-accredit`, params);
      let extras = _.isEmpty(selection) ? {} : { filter: { name: '', area: '' } };
      dispatch({ type: 'eventAccredit', payload: { selecteds: [], showAreaModal: false, ...extras }});
      mutate(data);
    } catch (error) {
      failure(error);
    }
  };

  const selectPersons = async (selection) => {
    let selecteds = _.map(selection, 'id');
    dispatch({ type: 'eventAccredit', payload: { selecteds }});
  };

  const changeFilter = async (filter) => {
    dispatch({ type: 'eventAccredit', payload: { filter, selecteds: [] }});
  };

  const openAreaModal = (modalData) => {
    dispatch({ type: 'eventAccredit', payload: { modalData, showAreaModal: true }});
  };

  const closeAreaModal = () => {
    dispatch({ type: 'eventAccredit', payload: { modalData: {}, showAreaModal: false }});
  };
 
  return {
    state: {
      ...eventAccredit,
      model: data,
      loading: !data
    },
    actions: {
      changeArea,
      selectPersons,
      changeFilter,
      openAreaModal,
      closeAreaModal
    }
  }
}

export default useEventAccredit;